module.exports = __webpack_public_path__ + "static/media/Salary65k.86c2d9e3.png";